import { TFunction } from 'next-i18next';

export function convertGender(gender: string | null | undefined, t: TFunction): string {
  switch (gender) {
    case 'H':
      return t('entities.patient.gender.man');
    case 'F':
      return t('entities.patient.gender.woman');
    default:
      return t('entities.patient.gender.other');
  }
}
